const appConfig = {
  "name": "physical-security-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "2b72mn9dandmhq36blhjsjhd5k",
    "redirectUris": [
      "https://physicalsecurity.mit.edu",
      "https://physicalsecurity-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://physicalsecurity.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "feedback/user",
      "mit:user:all.read",
      "notification/user",
      "offline_access",
      "openid",
      "phone",
      "physical-security/gatekeeper",
      "profile"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "2b72mn9dandmhq36blhjsjhd5k",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "feedback/user",
        "notification/user",
        "openid",
        "physical-security/gatekeeper",
        "profile",
        "user/all"
      ],
      "redirectUris": [
        "https://physicalsecurity.mit.edu",
        "https://physicalsecurity-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://physicalsecurity.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;